import { ControlledModalHeaderLeftButton } from "src/components/parts/headers/ControlledModalHeaderLeftButon"
import { commonModalOptions } from "./commonModalOptions"

export const commonStackedModalOptions = {
  ...commonModalOptions,
  headerLeft: ControlledModalHeaderLeftButton,
}
